export enum TokenType {
    ACCESS_TOKEN = 1,
    REFRESH_TOKEN = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/token-type.enum.ts